import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ImportEmployeesService {

  constructor(private http: HttpClient) {
  }

  upload(params) {
    return this.http.post<any>(`${environment.apiUrl}/imports/employees/upload`, params);
  }
  
  preview(params) {
    return this.http.post<any>(`${environment.apiUrl}/imports/employees/preview`, params);
  }

  start(params) {
    return this.http.post<any>(`${environment.apiUrl}/imports/employees/start`, params);
  }

  getStatus(id) {
    return this.http.get<any>(`${environment.apiUrl}/imports/employees/${id}/status`);
  }

  getImportsList() {
    return this.http.get<any>(`${environment.apiUrl}/imports/employees/list`);
  }
}
